<!-- <app-loader *ngIf="isLoading"></app-loader> -->
<div class="dialog-header">
  <h6>{{ isEditMode ? 'Edit Cargo' : 'Add Cargo' }}</h6>
  <button mat-icon-button class="close-icon" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<form [formGroup]="cargoForm" (ngSubmit)="onSubmit()">
  <mat-form-field appearance="outline">
    <mat-label>Cargo</mat-label>
    <input matInput formControlName="type" (keypress)="disallowNumericData($event);allowLimitedInput($event, 50)"
      (paste)="onPaste($event)" (blur)="onInputTrim('type')" />
    <mat-error *ngIf="cargoForm.get('type')?.hasError('required')">
      Cargo Name is required.
    </mat-error>
  </mat-form-field>
  <div>
    <button mat-flat-button color="primary" class="add-cargo" type="submit"> {{ isEditMode ? 'Update Cargo' : 'Add
      Cargo' }}</button>
  </div>
</form>